module.exports = __webpack_public_path__ + "static/media/results.c426aac1.svg";